import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { toast } from "react-toastify";
import { getMediaProperty } from "../../utils";
import { useMicrosite } from "../../custom-hooks/useMicrosite";
import UserIcon from "../../assets/images/icons/userLogo.svg";
import "./style.scss";

export default function MicrositeEdit({
  page,
  reloadFlagFunction,
  data,
  closeSettings,
}) {
  const [form] = Form.useForm();
  const [media, setMedia] = useState({});

 const { updateMicroSite } = useMicrosite();

  const submit = (values) => {
    if (
      (values && values.name && values.name !== data.name) ||
      (media && media.mediaProperty)
    ) {
      var formData = new FormData();
      if (media && media.blob) {
        formData.append("media", media.blob);
      }
      var valueData = {...values, website: data?.websiteLink};

      if (media && media.mediaProperty) {
        valueData.media = media.mediaProperty;
      }
      const json = JSON.stringify(valueData);
      const blob = new Blob([json], {
        type: "application/json",
      });
      formData.append("micrositeProfileInput", blob);

      updateMicroSite(data.id, formData, reloadFlagFunction, page);
    } else {
      toast.error("Nothing to update");
    }
  };
  const changeImage = (event) => {
    const MAX_SIZE = 2 * 1024 * 1024;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    var file = event.target.files[0].name;
    var FT = event.target.files[0].type;

    if(file && !allowedTypes.includes(FT)){
      toast.error("Only image files are allowed(JPG, PNG, JPEG)");
      return;
    } else if (event.target.files && event.target.files[0].size > MAX_SIZE) {
      toast.error("File should not exceed 2MB");
      return;
    } else {
      const media = getMediaProperty(event);
      setMedia(media);
    }
  };
  return (
    <Form onFinish={submit} form={form} initialValues={data} style={{ width: "100%" }}>
      <div className="ms-edit-main">
        <div className="ms-edit-left">
          <div className="ms-edit-media">
            {media && media.blob ? (
              <img className="edit-img" src={URL.createObjectURL(media.blob)} alt="" />
            ) : data && data.mediaLink ? (
              <img className="edit-img" src={data.mediaLink} alt="" />
            ) : (
              <img className="edit-img" src={UserIcon} alt="" />
            )}
            <div>
              <label name="file" className="fileUploadBtn greenBtn">
                {" "}
                Upload Image
                <input
                  accept="image/png, image/gif, image/jpeg"
                  type="file"
                  // required={true}
                  onChange={(e) => changeImage(e)}
                />
              </label>
            </div>
          </div>

          <Form.Item
            name={"name"}
            rules={[
              { required: true, message: "Site name  required" }, 
              { max: 40, message: "Site title cannot exceed 40 characters" }
            ]}
          >
            <Input placeholder="Site name" className="micrositename"/>
          </Form.Item>
        </div>
        <div className="ms-edit-right">
          <Button
            onClick={closeSettings}
            type="button"
            className="cancelBtn"
          >Cancel</Button>
          <Button
            label="Save"
            className="greenBtn"
            type="submit"
            onClick={() => form.submit()}
          >Save</Button>
        </div>
      </div>
    </Form>
  );
}
